export default __webpack_public_path__ + "static/media/logo.c0139a1d.svg";